import { Box, Text } from '@user-portal/wikr-components';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';

import { openModal } from 'store/modals/actions';

import {
    OfferTypes,
    cancelFlow_cancelOfferClick,
    cancelFlow_cancelOfferScreenLoad,
} from 'services/analytics/trackers/cancelFlow';
import { pauseFlow_pauseDetailsScreenLoad, pauseFlow_pauseResultClick } from 'services/analytics/trackers/pauseFlow';

import { useCancelSubscription, useModals, usePauseSubscription } from 'hooks';

import OutlinedButton from 'components/OutlinedButton';
import ModalHeader from 'components/ModalHeader';
import Modal from 'components/Modal';
import PauseOffer from './components/PauseOffer';

import * as S from './styled';

import { ModalName } from 'types/modals';

const PauseOfferModalContainer = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { closeModal } = useModals();
    const { cancellationCandidate, discardCancellation, onCancelSubscription } = useCancelSubscription();
    const { onPauseSubscription, subscriptionId } = usePauseSubscription();

    const headerTitle = cancellationCandidate
        ? t('subscription.text.cancel')
        : t('subscription.cancellation.pauseOffer.pauseBtnText');

    useEffect(() => {
        if (cancellationCandidate) {
            cancelFlow_cancelOfferScreenLoad({
                offer_type: OfferTypes.Pause_offer,
                subscription_id: cancellationCandidate.external_id,
            });
        } else {
            pauseFlow_pauseDetailsScreenLoad({
                subscription_id: subscriptionId,
            });
        }
    }, [cancellationCandidate, subscriptionId]);

    const goBack = () => {
        dispatch(openModal(ModalName.REASON_MODAL));
    };

    const handlePause = () => {
        onPauseSubscription(!cancellationCandidate);

        if (cancellationCandidate) {
            cancelFlow_cancelOfferClick({
                action: 'claim_offer',
                subscription_id: cancellationCandidate.external_id,
                offer_type: OfferTypes.Pause_offer,
            });
        } else {
            pauseFlow_pauseResultClick({
                action: 'claim_offer',
                subscription_id: subscriptionId,
            });
        }
    };

    const handleClose = () => {
        closeModal();
        discardCancellation();

        if (cancellationCandidate) {
            cancelFlow_cancelOfferClick({
                action: 'close',
                subscription_id: cancellationCandidate.external_id,
                offer_type: OfferTypes.Pause_offer,
            });
        } else {
            pauseFlow_pauseResultClick({
                action: 'close',
                subscription_id: subscriptionId,
            });
        }
    };

    const handleCancel = () => {
        onCancelSubscription();

        if (cancellationCandidate) {
            cancelFlow_cancelOfferClick({
                action: 'cancel',
                subscription_id: cancellationCandidate.external_id,
                offer_type: OfferTypes.Pause_offer,
            });
        }
    };

    return (
        <Modal isOpen fullscreen customStyles={{ content: { overflow: 'scroll' } }}>
            <>
                <ModalHeader onBack={cancellationCandidate ? goBack : null} onClose={handleClose} title={headerTitle} />
                <S.Container dataLocator="pauseOfferContainer">
                    <Box $paddingX={20}>
                        <Text type="h4" medium mb={12} center>
                            {t('subscription.cancellation.pauseOffer.title')}
                        </Text>
                        <Text type="large-text" mb={24} center>
                            {t('subscription.cancellation.pauseOffer.subtitle')}
                        </Text>
                    </Box>
                    <PauseOffer
                        mb={24}
                        badgeBackgroundColor="discount"
                        badgeText="subscription.cancellation.pauseOffer.badgeText"
                        onPauseSubscription={handlePause}
                    />
                    {cancellationCandidate && (
                        <OutlinedButton dataLocator="pauseOfferCancelSubscriptionButton" onClick={handleCancel}>
                            {t('subscription.text.cancel')}
                        </OutlinedButton>
                    )}
                </S.Container>
            </>
        </Modal>
    );
};

export default PauseOfferModalContainer;
